export default{
  cities: (state) => state.cities,
  city: (state) => state.city,
  blockCities: (state) => state.blockCities
}



// WEBPACK FOOTER //
// ./src/components/city/store/getters.js